import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Alert,
  Grid,
  Paper
} from '@mui/material';
import '../css/UserProfile.css';
import API_BASE_URL from '../api';

const UserProfile = () => {
  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    emailAddress: '',
    gender: ''
  });

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isPasswordEnabled, setIsPasswordEnabled] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchUser = async () => {
      const token = localStorage.getItem('authToken');
      try {
        const response = await axios.get(`${API_BASE_URL}/api/users/${userId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        const { firstName, lastName, emailAddress, gender } = response.data;
        setUser({ firstName, lastName, emailAddress, gender });
      } catch (error) {
        setError('Erreur lors de la récupération des informations utilisateur');
      }
    };

    fetchUser();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (isPasswordEnabled && newPassword !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    const token = localStorage.getItem('authToken');

    const updatedData = {
      ...user,
      ...(isPasswordEnabled && newPassword ? { password: newPassword } : {})
    };

    try {
      await axios.put(`${API_BASE_URL}/api/users/${userId}`, updatedData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setSuccess('Informations mises à jour avec succès');
      setError('');

      if (isPasswordEnabled) {
        setTimeout(() => {
          localStorage.removeItem('authToken');
          navigate('/login');
        }, 3000);
      }

    } catch (error) {
      setError("Erreur lors de la mise à jour.");
      setSuccess('');
    }
  };

  const togglePasswordFields = () => {
    setIsPasswordEnabled(!isPasswordEnabled);
    setNewPassword('');
    setConfirmPassword('');
  };

  return (
    <Box className="user-profile-container">
      <Sidebar />
      <Box className="main-content">
        <Paper elevation={3} className="profile-paper">
          <Typography variant="h5" gutterBottom>Mes informations</Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

          <form onSubmit={handleSave}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  select
                  label="Genre"
                  name="gender"
                  value={user.gender}
                  onChange={handleChange}
                  fullWidth
                  required
                >
                  <MenuItem value="">Sélectionner...</MenuItem>
                  <MenuItem value="Monsieur">Monsieur</MenuItem>
                  <MenuItem value="Madame">Madame</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Prénom"
                  name="firstName"
                  value={user.firstName}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  label="Nom"
                  name="lastName"
                  value={user.lastName}
                  onChange={handleChange}
                  fullWidth
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Email"
                  name="emailAddress"
                  value={user.emailAddress}
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <Button variant="outlined" onClick={togglePasswordFields}>
                  {isPasswordEnabled
                    ? 'Annuler la modification du mot de passe'
                    : 'Modifier mon mot de passe'}
                </Button>
              </Grid>

              {isPasswordEnabled && (
                <>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Nouveau mot de passe"
                      type="password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      fullWidth
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Confirmer le mot de passe"
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      fullWidth
                      required
                    />
                  </Grid>
                </>
              )}

              <Grid item xs={12}>
                <Button type="submit" variant="contained" className="save-button">
                  Sauvegarder
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </Box>
  );
};

export default UserProfile;
